import { useLocation, useNavigate } from "react-router-dom";
// material
import { Typography, Button, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import AddIcon from "@mui/icons-material/Add";
import Page from '../../../components/Page';
import IssueListingPage from "../../../components/SidebarMenuComponents/IssueComponent/IssueListingPage";
import StickyHeader from "../../../components/Common/StickyHeader";

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    // padding: theme.spacing(1, 1)
}));
export default function IssueList() {
    const navigate = useNavigate();

    const handleNavigate = () => {
        navigate('/dashboard/newissue');

    }

    return (
        <Page title="Issue List| tiketic" >
            <StickyHeader
                title="Issue Management"
                showButton="true"
                onButtonClick={handleNavigate}
            />

            <ContentStyle>
                <IssueListingPage />
            </ContentStyle>
            
        </Page>
    );
}

